import { render } from "./StudentLogin.vue?vue&type=template&id=0cf07f91&scoped=true"
import script from "./StudentLogin.vue?vue&type=script&lang=js"
export * from "./StudentLogin.vue?vue&type=script&lang=js"

import "./StudentLogin.vue?vue&type=style&index=0&id=0cf07f91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf07f91"]])

export default __exports__